import { Navigate, Route, Routes } from "react-router-dom";
import { DirectoryShell } from "@/components/Directory/DirectoryShell";
import { AccessPage } from "@/pages/AccessPage";
import { BillingPage } from "@/pages/BillingPage";
import { HomePage } from "@/pages/HomePage";
import { PeoplePage } from "@/pages/PeoplePage";
import { PersonDetailPage } from "@/pages/PersonDetailPage";
import { RequestsPage } from "@/pages/RequestsPage";
import { GroupsPage } from "@/pages/GroupsPage";
import { SecurityPage } from "@/pages/SecurityPage";

export function App() {
  return (
    <Routes>
      <Route element={<DirectoryShell />}>
        <Route index element={<HomePage />} />
        <Route path="/access" element={<AccessPage />} />
        <Route path="/people" element={<PeoplePage />} />
        <Route path="/people/:userId" element={<PersonDetailPage />} />
        <Route path="/requests" element={<RequestsPage />} />
        <Route path="/groups" element={<GroupsPage />} />
        <Route path="/security" element={<SecurityPage />} />
        <Route path="/billing" element={<BillingPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
